import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ShippingDetailsTab from './Freight/ShippingDetailsTab';
import RoutingTab from './Freight/RoutingTab';




const FreightTab = () => {

    return (
        <>
            <div>Need to work</div>
        </>
    )
}

export default FreightTab